import { createSelector } from 'reselect';

export const getLocation = (state) => state.location;

export const getLocationError = createSelector(
  getLocation,
  ({ error }) => error
);
export const isLocationLoading = createSelector(
  getLocation,
  ({ loading }) => loading
);

export const getLocationItems = createSelector(
  getLocation,
  ({ items }) => items
);
export const getLocationItem = createSelector(getLocation, ({ item }) => item);
